import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { InactiveCustomerAllowedEndpoints } from "./Constants/urlConstants";
import { AxiosInstance } from "axios";
import * as React from "react";
import { Route } from "react-router-dom";
import { QuarantineCreate, QuarantineEdit, QuarantineList, SourceQuarantine } from "../src/Pages/Quarantine";
import * as config from "./config";
import dataProvider from "./dataprovider";
import { CreateAircraft, EditAircraft, ListAircraft, SourceAircraft } from "./Pages/Admin/Aircraft";
import { CreateAircraftType, EditAircraftType, ListAircraftType, SourceAircraftType } from "./Pages/Admin/AircraftType";
import { CreateAirport, EditAirport, ListAirport, SourceAirport } from "./Pages/Admin/Airport";
import { CreateCustomer, EditCustomer, ListCustomer, SourceCustomer } from "./Pages/Admin/Customer";
import { CreateMelCategory, EditMelCategory, ListMelCategory, SourceMelCategory } from "./Pages/Admin/MelCategory";
import {
  CreateMelCategoryCustomer,
  EditMelCategoryCustomer,
  ListMelCategoryCustomer,
  SourceMelCategoryCustomer,
} from "./Pages/Admin/MelCategoryCustomer";
import { CreateMro, EditMro, ListMro, SourceMro } from "./Pages/Admin/Mro";
import { CreateReleaseType, EditReleaseType, ListReleaseType, SourceReleaseType } from "./Pages/Admin/ReleaseType";
import {
  CreateRemoveReasonDetail,
  EditRemoveReasonDetail,
  ListRemoveReasonDetail,
  SourceRemoveReasonTypeDetail,
} from "./Pages/Admin/RemovalReasonDetail";
import {
  CreateRemoveReason,
  EditRemoveReason,
  ListRemoveReason,
  SourceRemoveReasonTypes,
} from "./Pages/Admin/RemovalReasonType";
import {
  CreateAircraftUtilization,
  EditAircraftUtilization,
  ListAircraftUtilization,
} from "./Pages/AircraftUtilization";
import DashboardRbh from "./Pages/Dashboard/DashboardRbh";
import { Excusable, ExcusableDetail } from "./Pages/Excusable";
import {
  CustomsClearanceList,
  InitialReceivingList,
  ReasoningEvidenceList,
  RepairProcessDoneList,
  SourceRequestOrder,
  SourcePbhRequestOrder,
  WoWaitingList,
  WWVendorProcessList,
} from "./Pages/RequestOrder/Components";
import ArrivalInfoEdit from "./Pages/RequestOrder/Components/ArrivalInfoEdit";
import ManuelCoverageControlList from "./Pages/RequestOrder/Components/ManuelCoverageControlList";
import QuarantineStageList from "./Pages/RequestOrder/Components/QuarantineStage";
import QuarantineStageStep2List from "./Pages/RequestOrder/Components/QuarantineStageStep2";
import DispatchWaitingList from "./Pages/RequestOrder/Components/DispatchWaiting/DispatchWaitingList";
import RbhRequestOrderEdit from "./Pages/RequestOrder/Components/RbhRequestOrderEdit/RbhRequestOrderEdit";
import { RequestOrderList } from "./Pages/RequestOrder/Components/RequestOrderList/RequestOrderList";
import RequestStatusGroup from "./Pages/RequestOrder/Components/RequestStatusGroups/RequestStatusGroup";
import Status15 from "./Pages/RequestOrder/Components/Status15/Status15";
import DashboardPbh from "./Pages/Dashboard/Pbh/PbhDashboard/DashboardPbh";
import VendorRepairList from "./Pages/RequestOrder/Components/VendorRepair/VendorRepairList";
import WorkshopList from "./Pages/RequestOrder/Components/Workshop/WorkshopList";
import { ModelState } from "./Pages/RequestOrder/Models/ModelStateEnum";
import AbilityControl from "./Pages/AbilityControl/AbilityControl";
import { RequestStatusEdit, RequestStatusInfoList } from "./Pages/Admin/RequestStatusInfo";
import ShopReport from "./Pages/ShopReport/ShopReport";
import MinioDownload from "./Pages/MinioDownload/MinioDownload";
import { Resource } from "react-admin";
import MailManagementList from "./Pages/Admin/MailManagement/MailManagementList";
import MailManagementEdit from "./Pages/Admin/MailManagement/MailManagementEdit";
import Search from "./Pages/Report/Search/Search";
import HealthCheck from "./Pages/HealthCheck/HealthCheck";
import Experience, { SourceExperience } from "./Pages/Experience";
import HomebaseWarehouse, { SourceHomebaseWarehouse } from "./Pages/Homebase/HomebaseWarehouse";
import { SourceHomebaseWarehouseDetail } from "./Pages/Homebase/HomebaseWarehouse/Constant/Constant";
import HomebaseWarehouseDetail from "./Pages/Homebase/HomebaseWarehouse/HomebaseWarehouseDetail";
import { SourceHomebaseComponent } from "./Pages/Homebase/HomebaseComponent/Constant/Constant";
import HomebaseComponent from "./Pages/Homebase/HomebaseComponent";
import RequestOrderCreateCondition from "./Pages/RequestOrder/Components/RequestOrderCreateCondition/RequestOrderCreateCondition";
import PbhRequestList from "./Pages/RequestOrder/Components/PbhRequestOrderList/PbhRequestList";
import PbhRequestOrderEdit from "./Pages/RequestOrder/Components/PbhRequestOrderEdit/PbhRequestOrderEdit";
import { PbhRequestStatusEdit, PbhRequestStatusInfoList } from "./Pages/Admin/PbhRequestStatusInfo";
import Cockpit from "./Pages/Cockpit/Cockpit";
import { SourceCoreInfoRequest } from "./Pages/CoreInfoRequest/Source";
import CoreInfoRequestCreate from "./Pages/CoreInfoRequest/CoreInfoRequestCreate";
import CoreInfoRequestList from "./Pages/CoreInfoRequest/CoreInfoRequestList";
import CoreInfoRequestEdit from "./Pages/CoreInfoRequest/CoreInfoRequestEdit";
import { sourceAUM } from "./Pages/AircraftUnderMaintenance/Constants/Constants";
import AircraftUnderMaintenance from "./Pages/AircraftUnderMaintenance/index";
import Loading from "./Components/Loading/Loading";
import { MenuFilters } from "./MenuFilters";
import FailOnFitList from "./Pages/Reliability/FailOnFit/FailOnFitList";
import FailOnFitDetail from "./Pages/Reliability/FailOnFit/FailOnFitDetail";
import FailOnFit from "./Pages/Reliability/FailOnFit/FailOnFit";
import SearchMenuInput from "./Components/Search/Search";
import { AirborneApp, getEnvironmentConfig, IUser, useAuth } from "@airborne/react-admin";
import MailManagementCreate from "./Pages/Admin/MailManagement/MailManagementCreate";
import MailSchemaCreate from "./Pages/Admin/MailSchema/MailSchemaCreate";
import MailSchemaList from "./Pages/Admin/MailSchema/MailSchemaList";
import MailSchemaEdit from "./Pages/Admin/MailSchema/MailSchemaEdit";
import rootReducer from "./Redux/reducers";
import RejectedPoolScopeList from "./Pages/RequestOrder/Components/RejectedPoolScopeList";
import OldDataExportList from "./Pages/OldDataExport/OldDataExportList";
import CustomerUser from "./Pages/Admin/CustomerUser";
import NavBarOwnerSelection from "./Components/OwnerSelection/NavBarOwnerSelection";
import "./styles/global.css";
import InitialDashboard from "./Pages/Dashboard/InitialDashboard";
import { SourceReliabilityExclusionPn } from "./Pages/Reliability/ExclusionPn/Source";
import ReliabilityExclusionPnList from "./Pages/Reliability/ExclusionPn/ReliabilityExlusionPnList";
import ReliabilityExclusionPnCreate from "./Pages/Reliability/ExclusionPn/ReliabilityExclusionPnCreate";
import ReliabilityExclusionPnEdit from "./Pages/Reliability/ExclusionPn/ReliabilityExclusionPnEdit";
import ThyFailOnFit from "./Pages/Reliability/ThyFailOnFit/ThyFailOnFit";
import ThyFailOnFitDetail from "./Pages/Reliability/ThyFailOnFit/ThyFailOnFitDetail";
import PrematureFailureList from "./Pages/Reliability/PrematureFailure/PrematureFailureList";
import PrematureFailureDetail from "./Pages/Reliability/PrematureFailure/PrematureFailureDetail";
import PrematureFailure from "./Pages/Reliability/PrematureFailure/PrematureFailure";
import ThyPrematureFailure from "./Pages/Reliability/ThyPrematureFailure/ThyPrematureFailure";
import ThyPrematureFailureList from "./Pages/Reliability/ThyPrematureFailure/ThyPrematureFailureList";
import ThyPrematureFailureDetail from "./Pages/Reliability/ThyPrematureFailure/ThyPrematureFailureDetail";
import RedisClearCache from "./Pages/Admin/Redis/Redis";
import { FlightRadarFetch } from "./Pages/Admin/FlightRadar";
import { FrBulkFetchPage } from "./Pages/Admin/FrBulkFetch";
import FileTransfer from "./Pages/Admin/FileTransfer/FileTransfer";
import { SourceEightWings } from "./Pages/RequestOrder/Components/Constant/Source";
import EightWingsEdit from "./Pages/RequestOrder/Components/EightWings/EightWingsEdit";
import {
  AarStorageCreate,
  AarStorageList,
  AarStorageUpdate,
  SourceAarStorage,
} from "./Pages/RequestOrder/Components/AarStorage";
import sourceAuthorizationList from "./sourceAuthorizationList";
import EightWingsTTVerifyList from "./Pages/RequestOrder/Components/EightWings/EightWingsTTVerify/EightWingsTTVerifyList";
import EightWingsList from "./Pages/RequestOrder/Components/EightWings/EightWingsList/EightWingsList";
import Rogue from "./Pages/Reliability/Rogue/Rogue";
import RogueList from "./Pages/Reliability/Rogue/RogueList";
import RogueDetail from "./Pages/Reliability/Rogue/RogueDetail";
import DirectDeliveryToFz from "./Pages/RequestOrder/Components/EightWings/DirectDeliveryToFz/DirectDeliveryToFz";
import WaitingCoreReturn from "./Pages/RequestOrder/Components/EightWings/WaitingCoreReturn/WaitingCoreReturn";
import ShippingAddressList from "./Pages/Admin/ShippingAddress/ShippingAddressList";
import ShippingAddressCreate from "./Pages/Admin/ShippingAddress/ShippingAddressCreate";
import ShippingAddressEdit from "./Pages/Admin/ShippingAddress/ShippingAddressEdit";
import LocalRepairComponentList from "./Pages/Admin/LocalRepairComponents/LocalRepairComponentList";
import LocalRepairComponentCreate from "./Pages/Admin/LocalRepairComponents/LocalRepairComponentCreate";
import LocalRepairComponentEdit from "./Pages/Admin/LocalRepairComponents/LocalRepairComponentEdit";
import { SourcePbhStatusUpdate } from "./Pages/RequestOrder/Components/PbhStatusUpdate/PbhStatusUpdateConstant";
import PbhStatusUpdate from "./Pages/RequestOrder/Components/PbhStatusUpdate/PbhStatusUpdateList";
import PbhStatusUpdateCreate from "./Pages/RequestOrder/Components/PbhStatusUpdate/PbhStatusUpdateCreate";
import ExcusableListRBH from "./Pages/Excusable/ExcusableListRBH";
import ExcusableListPBH from "./Pages/Excusable/ExcusableListPBH";
import { LoadingProvider } from "./Components/Loading/LoadingContext";
import { AiAssistantProvider, AiAssistantBubble } from "./Components/AiAssistant";
import LoadingOverlay from "./Components/Loading/LoadingOverlay";
import CmsDashboard from "./Pages/Dashboard/CmsDashboard";
import NffReport from "./Pages/Reliability/NffReport/NffReport";
import NffReportList from "./Pages/Reliability/NffReport/NffReportList";
import NffReportExclusionPnCreate from "./Pages/Reliability/NffReportExclusionPn/NffReportExclusionPnCreate";
import NffReportExclusionPnList from "./Pages/Reliability/NffReportExclusionPn/NffReportExclusionPnList";
import NffReportExclusionPnEdit from "./Pages/Reliability/NffReportExclusionPn/NffReportExclusionPnEdit";
import { SourceNffReportExclusionPn } from "./Pages/Reliability/NffReportExclusionPn/Source";

const envConfig = getEnvironmentConfig(config);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    "@global": {
      "*::-webkit-scrollbar": {
        width: "10px",
        height: "10px",
      },
      "*::-webkit-scrollbar-track": {
        "-webkit-box-shadow": "inset 0 0 10px #ddd",
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "#c80c0f",
        borderRadius: "15px",
      },
      "*::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#c80c0f",
        borderRadius: "15px",
        border: "solid 1px #ddd",
      },
    },
  })
);
const getCustomerUser: any = async (http: AxiosInstance) => {
  const { data } = await http.get(`${envConfig.apiBaseUrl}/customerusers/getcustomeruserbyregisterid`);
  const result = data?.ownerCode !== null && data?.ownerCode !== undefined ? data : null;
  return result;
};

const userExtend = async ({ user, http }: { user: IUser; http: AxiosInstance }) => {
  const customerUser = user?.isCustomer ? await getCustomerUser(http) : null;
  let extendUser = Object.assign(
    { ownerCode: user?.isCustomer ? (customerUser?.ownerCode ?? user.customerCode) : "TTMS" },
    user
  );
  const { data } = await http.get(`${envConfig.apiBaseUrl}/customers/getcustomerbyowner/${extendUser.ownerCode}`);
  if (data === null) {
    return {
      permissions: [],
      roles: [],
      can: false,
    };
  }

  return Object.assign(
    {
      customerCode: data?.customerCode,
      customerName: data?.customerName,
      entegrationCode: data?.entegrationCode,
      customerId: data?.id,
      relatedCustomerCode: data?.relatedCustomerCode,
      isOwnerCodeEditable:
        user?.isCustomer && (customerUser === null || customerUser?.isEditable) && data?.relatedCustomerCode,
      isActive: data?.isActive,
    },
    extendUser
  );
};

const slowDataProvider: any = {
  ...dataProvider,
  getList: (Resource, params) => {
    var tempParams: any = { ...params };
    //when clicked the export excel button.
    if (
      (Resource == "shopreports" && tempParams?.pagination?.perPage == 1000) ||
      (Resource == "ModReports" && tempParams?.pagination?.perPage == 1000)
    ) {
      tempParams.pagination.perPage = 5000;
    }
    return dataProvider.getList(Resource, tempParams);
  },
};

const inactiveCustomerRef = { current: false };

const InactiveCustomerGuard = () => {
  const { user } = useAuth();
  React.useEffect(() => {
    inactiveCustomerRef.current = user?.isCustomer === true && user?.isActive === false;
  }, [user?.isCustomer, user?.isActive]);
  return null;
};


// Intercept every HTTP write operation at the axios level so all custom
// dataProvider methods (put, post, etc.) are blocked for inactive customers.
(dataProvider as any).http?.interceptors?.request?.use((axiosConfig: any) => {
  const method = axiosConfig.method?.toUpperCase();
  const url: string = axiosConfig.url ?? "";
  if (
    inactiveCustomerRef.current &&
    (method === "POST" || method === "PUT" || method === "DELETE" || method === "PATCH") &&
    !InactiveCustomerAllowedEndpoints.some(endpoint => url.includes(endpoint))
  ) {
    const err: any = new Error("Your account is inactive. Write operations are not allowed.");
    err.response = { status: 403, data: { message: err.message } };
    return Promise.reject(err);
  }
  return axiosConfig;
});

const App = () => {
  React.useEffect(() => {
    document.addEventListener("copy", handleCopy);
    // clear event
    return () => {
      document.removeEventListener("copy", handleCopy);
    };
  }, []);
  const [menuFilterVale, setMenuFilterValue] = React.useState("");
  const onChange = value => {
    setMenuFilterValue(value);
  };
  const handleCopy = event => {
    const selection = document.getSelection();
    if (selection && event?.target?.offsetParent?.toString?.()?.includes?.("Table")) {
      // Combine the copied the DataGrid rows in apply inline copying.
      event.clipboardData.setData("text/plain", selection.toString().replaceAll("\n", " "));
      event.preventDefault();
    }
  };
  return (
    <LoadingProvider>
      <AiAssistantProvider>
        <AiAssistantBubble />
        <LoadingOverlay />
        <AirborneApp
          customReducers={rootReducer}
          navbar={{
            additionalItems: [<Loading />, <NavBarOwnerSelection />, <InactiveCustomerGuard />],
            appLogo: <SearchMenuInput onChange={onChange} />,
          }}
          config={envConfig}
          dataProvider={slowDataProvider}
          menuFilters={MenuFilters(menuFilterVale)}
          transformUser={userExtend}
          dashboard={InitialDashboard}
          customRoutes={[
            <Route path="/requestorders/condition" component={RequestOrderCreateCondition} />,
            <Route path="/requestorders/list" component={RequestOrderList} />,
            <Route path="/pbhrequestorders/list" component={PbhRequestList} />,
            <Route path="/eightwings/list" component={EightWingsList} />,
            <Route path="/reasoningevidence" component={ReasoningEvidenceList} />,
            <Route path="/initialreceiving" component={InitialReceivingList} />,
            <Route path="/customsclearance" component={CustomsClearanceList} />,
            <Route path="/repairprocess" component={RepairProcessDoneList} />,
            <Route path="/wwvendorprocess" component={WWVendorProcessList} />,
            <Route path="/shopreport" component={ShopReport} />,
            <Route path="/workshop" component={WorkshopList} />,
            <Route path="/vendorrepair" component={VendorRepairList} />,
            <Route path="/dispatchwaiting" component={DispatchWaitingList} />,
            <Route path="/abilitycontrol" component={AbilityControl} />,
            <Route path="/tobeshop" component={Status15} />,
            <Route path="/wowaitinglist" component={WoWaitingList} />,
            <Route path="/rejectedpoolscope" component={RejectedPoolScopeList} />,
            <Route path="/manuelcoveragecontrol" component={ManuelCoverageControlList} />,
            <Route path="/requeststatusgroup" component={RequestStatusGroup} />,
            <Route path="/quarantinestage" component={QuarantineStageList} />,
            <Route path="/quarantinestagestep2" component={QuarantineStageStep2List} />,
            <Route path="/dashboardpbh" component={DashboardPbh} />,
            <Route path="/dashboardrbh" component={DashboardRbh} />,
            <Route path="/search" component={Search} />,
            <Route path="/healthcheck" component={HealthCheck} />,
            <Route path="/cockpit" component={Cockpit} />,
            <Route path="/failonfit" component={FailOnFit} />,
            <Route path="/thyfailonfit" component={ThyFailOnFit} />,
            <Route path="/prematurefailure" component={PrematureFailure} />,
            <Route path="/thyprematurefailure" component={ThyPrematureFailure} />,
            <Route path="/redis" component={RedisClearCache} />,
            <Route path="/filetransfer" component={FileTransfer} />,
            <Route path="/eightwingsttverify" component={EightWingsTTVerifyList} />,
            <Route path="/directdeliverytofz" component={DirectDeliveryToFz} />,
            <Route path="/waitingcorereturn" component={WaitingCoreReturn} />,
            <Route path="/rogue" component={Rogue} />,
            <Route path="/nffreport" component={NffReport} />,
            <Route path="/excusable/rbh" component={ExcusableListRBH} />,
            <Route path="/excusable/pbh" component={ExcusableListPBH} />,
            <Route path="/dashboardcms" component={CmsDashboard} />,
            <Route path="/flight-radar" component={FlightRadarFetch} />,
            <Route path="/fr-bulk-fetch" component={FrBulkFetchPage} />,
          ]}
        >
          <Resource name="requeststatusinfos" list={RequestStatusInfoList} edit={RequestStatusEdit} />
          <Resource name="PbhRequestStatusInfos" list={PbhRequestStatusInfoList} edit={PbhRequestStatusEdit} />
          <Resource
            name="mailmanagements"
            list={MailManagementList}
            edit={MailManagementEdit}
            create={MailManagementCreate}
          />
          <Resource
            name="shippingaddresss"
            list={ShippingAddressList}
            edit={ShippingAddressEdit}
            create={ShippingAddressCreate}
          />
          <Resource
            name="localrepaircomponents"
            list={LocalRepairComponentList}
            edit={LocalRepairComponentEdit}
            create={LocalRepairComponentCreate}
          />
          {sourceAuthorizationList.map((sourceName, index) => (
            <Resource key={index} name={sourceName} />
          ))}
          <Resource name="mailschemas" list={MailSchemaList} edit={MailSchemaEdit} create={MailSchemaCreate} />
          {/* <Resource name="ModReports" list={ModList} edit={ModListDetail} /> */}
          {/* <Resource name="requestworkflows" list={RequestWorkFlow} /> */}
          <Resource name={SourceEightWings} edit={EightWingsEdit} />
          <Resource
            name={SourcePbhRequestOrder}
            edit={() => <PbhRequestOrderEdit ModelState={ModelState.Edit} DataSource={null} />}
            create={() => <PbhRequestOrderEdit ModelState={ModelState.Create} DataSource={null} />}
          />
          <Resource
            name={SourceRequestOrder}
            edit={() => <RbhRequestOrderEdit ModelState={ModelState.Edit} DataSource={null} />}
            create={() => <RbhRequestOrderEdit ModelState={ModelState.Create} DataSource={null} />}
          />
          <Resource name="miniodownload" edit={MinioDownload} />
          <Resource name="requestarrivalinfos" edit={ArrivalInfoEdit} />

          <Resource name={SourceQuarantine} list={QuarantineList} edit={QuarantineEdit} create={QuarantineCreate} />
          <Resource
            name={SourceCoreInfoRequest}
            create={CoreInfoRequestCreate}
            list={CoreInfoRequestList}
            edit={CoreInfoRequestEdit}
          />
          <Resource name={SourceCustomer} list={ListCustomer} edit={EditCustomer} create={CreateCustomer} />
          <Resource name={SourceMro} list={ListMro} edit={EditMro} create={CreateMro} />
          <Resource
            name={SourceAircraftType}
            list={ListAircraftType}
            edit={EditAircraftType}
            create={CreateAircraftType}
          />
          <Resource name={SourceAircraft} list={ListAircraft} edit={EditAircraft} create={CreateAircraft} />
          <Resource
            name={SourceRemoveReasonTypes}
            list={ListRemoveReason}
            edit={EditRemoveReason}
            create={CreateRemoveReason}
          />
          <Resource
            name={SourceRemoveReasonTypeDetail}
            list={ListRemoveReasonDetail}
            edit={EditRemoveReasonDetail}
            create={CreateRemoveReasonDetail}
          />
          <Resource name={SourceReleaseType} list={ListReleaseType} edit={EditReleaseType} create={CreateReleaseType} />
          <Resource name={SourceAarStorage} list={AarStorageList} edit={AarStorageUpdate} create={AarStorageCreate} />
          <Resource name={SourceMelCategory} list={ListMelCategory} edit={EditMelCategory} create={CreateMelCategory} />
          <Resource
            name={SourceMelCategoryCustomer}
            list={ListMelCategoryCustomer}
            edit={EditMelCategoryCustomer}
            create={CreateMelCategoryCustomer}
          />
          <Resource name={SourceAirport} list={ListAirport} edit={EditAirport} create={CreateAirport} />
          <Resource
            name="aircraftutilizations"
            list={ListAircraftUtilization}
            edit={EditAircraftUtilization}
            create={CreateAircraftUtilization}
          />
          <Resource name={SourceExperience} {...Experience} />
          <Resource name={SourcePbhStatusUpdate} list={PbhStatusUpdate} create={PbhStatusUpdateCreate} />
          <Resource name={SourceHomebaseWarehouse} {...HomebaseWarehouse} />
          <Resource name={SourceHomebaseWarehouseDetail} list={HomebaseWarehouseDetail} />
          <Resource name={SourceHomebaseComponent} {...HomebaseComponent} />
          <Resource name={sourceAUM} {...AircraftUnderMaintenance} />
          <Resource name="reliabilityfailonfits" list={FailOnFitList} edit={FailOnFitDetail} />
          <Resource name="wsrequestreports" list={OldDataExportList} />
          <Resource name="customerusers" {...CustomerUser} />
          <Resource
            name={SourceReliabilityExclusionPn}
            create={ReliabilityExclusionPnCreate}
            list={ReliabilityExclusionPnList}
            edit={ReliabilityExclusionPnEdit}
          />
          <Resource name="reliabilitythyfailonfits" list={FailOnFitList} edit={ThyFailOnFitDetail} />
          <Resource name="reliabilityprematurefailures" list={PrematureFailureList} edit={PrematureFailureDetail} />
          <Resource
            name="reliabilitythyprematurefailures"
            list={ThyPrematureFailureList}
            edit={ThyPrematureFailureDetail}
          />
          <Resource name="reliabilityrogues" list={RogueList} edit={RogueDetail} />
          <Resource name="reliabilitynffreports" list={NffReportList} />
          <Resource
            name={SourceNffReportExclusionPn}
            create={NffReportExclusionPnCreate}
            list={NffReportExclusionPnList}
            edit={NffReportExclusionPnEdit}
          />
          <Resource name="requestorderexcusables" create={Excusable} edit={ExcusableDetail} />
          <Resource name="requestordersexcusables/rbh" create={Excusable} edit={ExcusableDetail} />
        </AirborneApp>
      </AiAssistantProvider>
    </LoadingProvider>
  );
};
export default App;
